//
// Module for the Dynamic Flow Wizard's 'Favorite Destinations' step 
//
rs.module("content/development/codedemos/dynamicflowwizard/favoritedestinationsstep",

    ["controls/navigation/wizard", "controls/components/event-banner"],

    function (wizard, eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var addFavoriteDestinationLink = stepContainer.js(jsSelectors.addFavoriteDestinationLink);
            var deleteFavoriteDestinationLink = stepContainer.js(jsSelectors.deleteFavoriteDestinationLink, { required: false, multiple: true });

            // Get the wizard's next button
            var wizardNextButton = $(`[data-wizard]`).js("_next");

            // Get the form (this will be the wizard form)
            var _form = stepContainer.closest("form");

            // Reset validation
            $.validator.resetValidation(_form);

            // Handle the Add Favorite Destination link click event
            if (addFavoriteDestinationLink) {

                addFavoriteDestinationLink.on('click', function () {

                    $.post(
                        {
                            url: backendUrls.setAddingFavoriteDestinationIndicator,
                            headers: wizard.getNavigationToken()
                        }
                    ).done(function (html, status, xhr) {

                        // Advance the wizard to the next step (Favorite Destination Add step)
                        wizardNextButton.click()

                    }).always(function (html, status, xhr) {

                    });
                });
            }

            // Handle the Delete Favorite Destination link click event
            if (deleteFavoriteDestinationLink) {

                deleteFavoriteDestinationLink.on('click', function () {

                    var destinationKey = $(this).data("destinationkey");
                    var destinationListItem = $(this).closest('li'); // Find the wrapping <li> tag

                    $.post(
                        {
                            url: backendUrls.deleteFavoriteDestination,
                            headers: wizard.getNavigationToken(),
                            data: { destinationKey: destinationKey }
                        }
                    ).done(function (html, status, xhr) {

                        // Remove the wrapping <li> tag from the DOM
                        destinationListItem.remove();

                    }).always(function (html, status, xhr) {

                    });
                });
            }

            wizard.onPausing(function () {
                return new Promise((resolve, reject) => {
                    // this would be replaced with a backend call, calling resolve() or reject() based on success/failure as desired
                    // to cancel the pause.  Or to display a message/prompt.
                    resolve();

                    // to cancel the Pause, call reject(). It would be recommended to use eventBanner and 
                    // dispatch an error message in this situation.
                });
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);